

import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';

const Payment2 = () => {
    const { state } = useLocation();
    const { name, contactNo, email, address, state: userState, zip, product, cartItems, payableAmount, orderTotal } = state || {};


    const [transactionId, setTransactionId] = useState('');
    const [paymentScreenshot, setPaymentScreenshot] = useState(null);
    const [loading, setLoading] = useState(false);
    const [paymentCompleted, setPaymentCompleted] = useState(false);
    const [orderid, setOrderid] = useState("");

    const [transactionIdError, setTransactionIdError] = useState('');
    const [paymentScreenshotError, setPaymentScreenshotError] = useState('');

    const handleFileChange = (event) => {
        setPaymentScreenshot(event.target.files[0]);
        setPaymentScreenshotError('');
    };

    const handleTransactionIdChange = (event) => {
        setTransactionId(event.target.value);
        setTransactionIdError('');
    };



    const gst = Math.round(payableAmount * 0.18)

    const URL1 = "https://nyus.5techg.com";
    const URL2 = "https://fivetechyuswearbackend-a4li.onrender.com";

    useEffect(() => {
        if (paymentCompleted) {
            alert('Payment successful!', orderid);
            setTransactionId('');
            setPaymentScreenshot(null);
            setPaymentCompleted(false);
            setLoading(false);
        }
    }, [paymentCompleted, orderid]);

    const navigate = useNavigate();

    // const ondowload = () => {
    //     window.open("eyeimage/qrcode/orignalqr.jpeg");
    // };

    const ondowload = () => {
        const link = document.createElement('a');
        link.href = 'eyeimage/qrcode/orignalqr.jpeg';
        link.download = 'nyus-qr-code.jpg';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };


    const handlePaymentSubmit = async () => {
        // Validation
        let valid = true;
        if (!transactionId) {
            setTransactionIdError('Transaction ID is required.');
            valid = false;
        }
        if (!paymentScreenshot) {
            setPaymentScreenshotError('Payment screenshot is required.');
            valid = false;
        }

        if (!valid) return;

        setLoading(true);
        const formData = new FormData();

        formData.append('cname', name);
        formData.append('cemail', email);
        formData.append('contactNo', contactNo);
        formData.append('address', address);
        formData.append('state', userState);
        formData.append('zipCode', zip);
        formData.append('paymentTransactionNo', transactionId);
        formData.append('paymentScreenshot', paymentScreenshot);

        formData.append('productId', product.id);
        formData.append('productName', product.ProductName);
        formData.append('quantity', 1);
        formData.append('price', product.Price);
        // formData.append('productimage', `https://nyus.5techg.com/${product.selectedImage}`);

        try {
            const response = await axios.post(`${URL1}/orders/new_order`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            setPaymentCompleted(true);

            const orderids = response.data.orderId;
            console.log('Payment successful', orderids);
            setOrderid(orderids);
            navigate('/Order-confirm', { state: { orderId: response.data.orderId } });
        } catch (error) {
            console.error('Error making payment', error);
            setLoading(false);
        }
    };

    if (!state) {
        return <p>Data is missing, please go back to checkout.</p>;
    }

    console.log("Payment Data:", state);

    return (
        <div>
            <p className="mt-36 ml-20 text-2xl font-medium">Payment Methods</p>
            <div className='mb-10 lg:mx-20 gap-4 lg:grid lg:grid-cols-2'>
                <div className='border bg-gray-50 mt-4 p-4'>
                    <h1 className='text-lg font-bold'>Order Summary</h1>
                    <div key={product.id} className='lg:grid lg:grid-cols-2'>
                        <h3 className='mt-4 hidden'>Product Name: <span className='font-semibold'>{product.id}</span></h3>
                        <h3 className='mt-4'>Product Name: <span className='font-semibold'>{product.ProductName}</span></h3>
                        <h3 className='mt-2'>Qty: <span className='font-semibold'>1</span></h3>
                        <h3 className='mt-2'>Rate per product: <span className='font-semibold'>Rs. {product.Price - product.Discount}</span></h3>
                        <h3 className='mt-2'>Description: <span className='font-semibold'>{product.Description}</span></h3>
                        {/* <img src={`https://nyus.5techg.com/${product.selectedImage}`} className="hidden"></img> */}
                    </div>
                    <br></br>
                    <hr></hr>
                    <h1 className='text-lg mt-4 font-bold'>Address Summary</h1>
                    <div className='md:grid md:grid-cols-2'>
                        <h3 className='mt-4'>Your Name: <span className='font-semibold'>{name}</span></h3>
                        <h3 className='mt-2'>Address: <span className='font-semibold'>{address}</span></h3>
                        <h3 className='mt-2'>Contact No.: <span className='font-semibold'>{contactNo}</span></h3>
                        <h3 className='mt-2'>Email: <span className='font-semibold'>{email}</span></h3>
                        <h3 className='mt-2'>Pin: <span className='font-semibold'>{zip}</span></h3>
                    </div>

                    <div className='border bg-gray-100 mt-2 '>
                        <div className='grid grid-cols-3'>
                            <div>

                            </div>
                            <h4 className='text-center text-md py-3'>Total :  </h4>
                            <span className=' my-auto justify-center flex item-center  text-md'>Rs. {payableAmount}</span>
                        </div>
                        <hr />
                        <div className='grid grid-cols-3'>
                            <div>

                            </div>
                            <h4 className='text-center text-md py-3'>Gst 18 % :  </h4>
                            <span className=' my-auto justify-center flex item-center  text-md'>Rs. {gst}</span>
                        </div>
                        <hr />

                        <div className='grid grid-cols-3'>
                            <div>

                            </div>
                            <h4 className='text-center font-semibold  text-xl py-3'>Total  Amount : </h4>
                            <span className='font-semibold my-auto  justify-center flex item-center'>Rs. {payableAmount + gst}</span>

                        </div>
                    </div>
                </div>
                <div className='sm:grid sm:grid-cols-2 mt-4'>
                    <div className='border p-4'>
                        <img className='w-60 mx-auto' src='eyeimage/qrcode/lensPlus.jpeg' alt="QR code" />
                        <p className='text-center'>Scan Or Download</p>
                        <button onClick={ondowload} className='border bg-yellow-400 w-full py-2'>Download QR</button>
                    </div>
                    <div>
                        <div className='p-4'>
                            <label htmlFor="transaction_id" className="block mb-2 text-sm font-medium text-gray-900">Transaction ID</label>
                            <input
                                type="text"
                                id="transaction_id"
                                value={transactionId}
                                onChange={handleTransactionIdChange}
                                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                                placeholder="Enter Transaction ID"
                                required
                            />
                            {transactionIdError && (
                                <p className="text-red-500 text-sm">{transactionIdError}</p>
                            )}
                        </div>
                        <div className="font-[sans-serif] max-w-md mx-auto p-4">
                            <label className="text-base text-gray-500 font-semibold mb-2 block">Upload Screenshot</label>
                            <input
                                type="file"
                                onChange={handleFileChange}
                                className="w-full text-gray-400 font-semibold text-sm bg-white border file:cursor-pointer cursor-pointer file:border-0 file:py-3 file:px-4 file:mr-4 file:bg-gray-100 file:hover:bg-gray-200 file:text-gray-500 rounded"
                            />
                            {paymentScreenshotError && (
                                <p className="text-red-500 text-sm">{paymentScreenshotError}</p>
                            )}
                        </div>
                        {loading ? (
                            <button className='m-4 border mt-4 w-full py-2 bg-indigo-600 hover:bg-indigo-700 text-white'>
                                Loading...
                            </button>
                        ) : (
                            <div>
                                <button
                                    onClick={handlePaymentSubmit}
                                    className='m-4 border mt-4 w-full py-2 bg-indigo-600 hover:bg-indigo-700 text-white'
                                    disabled={loading}
                                >
                                    Complete Payment
                                </button>
                                <div className='flex gap-x-4'>
                                    <h4 className='ml-4 font-semibold  text-lg '>Note </h4>
                                    <p className='font-semibold text-xs'>Record VIDEO when open the package  check for damages, Missing or Wrong item. otherwise Return will NOT be accepted.</p>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Payment2;
